var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#809B9D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9981,
    cy: 36.5118,
    r: 16.7442,
    fill: "#939C98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7215 59.9567C23.3378 59.6814 16.3584 75.3945 15.2459 78.3981C15.1642 78.6186 15.2383 78.8511 15.4228 78.997C20.8204 83.2674 31.5471 92.8074 47.7215 93C63.974 93.1935 74.7701 83.7809 80.4268 79C80.5767 78.8734 80.6477 78.6904 80.607 78.4984C80.031 75.7802 75.4383 60.2696 47.7215 59.9567Z",
    fill: "#939C98"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcct);
export default __webpack_public_path__ + "static/media/acct.26b5d8972be089aa194cab8775bacda9.svg";
export { ForwardRef as ReactComponent };